module.exports = __webpack_public_path__ + "img/favicon.083556e9.png";